import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { useContextSelector as useCS } from 'use-context-selector';
import { Skeleton, useMediaQuery } from '@mui/material';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import {
  Header,
  UserProfileMenu,
  ProfileRightBlockHeader,
  UserProfileMobileMenu,
} from 'view/components';
import { theme } from 'view/themes/theme';
import * as S from './styled';

const UserProfileLayout: FC = () => {
  const matches = useMediaQuery(theme.breakpoints.down('tablet'));
  const isReady = useCS(GlobalConfigContext, globalConfigSelectors.isReady);

  return (
    <S.Wrapper>
      <Header />
      <S.MainContentWrapper>
        {!matches ? <UserProfileMenu /> : null}
        <S.RightBlockWrapper>
          {!matches ? <ProfileRightBlockHeader /> : <UserProfileMobileMenu />}
          <S.RightBlockMain isReady={isReady}>
            {isReady ? (
              <Outlet />
            ) : (
              <Skeleton
                sx={{ borderRadius: '24px' }}
                variant="rectangular"
                animation="wave"
                width="100%"
                height="100%"
              />
            )}
          </S.RightBlockMain>
        </S.RightBlockWrapper>
      </S.MainContentWrapper>
    </S.Wrapper>
  );
};

export default UserProfileLayout;
